// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/legal-message/app/css/app.css
// module id = 453
// module chunks = 0